import { Button, Modal, Form, Row, Col, Input, message, Checkbox } from "antd";
import { useState } from "react";
import postDataRoad from "../../../../services/postDataRoad";

type RequiredMark = boolean | "optional";

export default function CreateSource({ isVisible, setVisible, refetch }: any) {
  const [isLoading, setLoading] = useState(false);
  const [isActive, setActive] = useState(true);
  const [requiredMark, setRequiredMarkType] =
    useState<RequiredMark>("optional");

  const [form] = Form.useForm();

  const onSubmit = async () => {
    setLoading(true);
    const values = await form.validateFields();
    const uri = "sources";
    const data = { isActive, ...values };
    const response = await postDataRoad(data, uri);
    setLoading(false);
    setVisible(false);
    if (response.success) {
      refetch();
      message.success("Source added successfully");
    } else {
      message.error(response.message);
    }
  };

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      visible={isVisible}
      title="Create Source"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createSource"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createSource"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
        initialValues={{ requiredMarkValue: requiredMark }}
        requiredMark={requiredMark}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="name"
              label="Source"
              rules={[
                {
                  required: true,
                  message: "Please enter source",
                },
              ]}
            >
              <Input placeholder="Source" />
            </Form.Item>
          </Col>
        </Row>

        <div className="my-2">
          <Checkbox checked={isActive} onChange={() => setActive(!isActive)}>
            Active
          </Checkbox>
        </div>
      </Form>
    </Modal>
  );
}
